import React, {
    createContext,
    useContext,
    useState,
    ReactNode,
    useEffect,
} from 'react';
import { AssinaturasService } from './Service';

const service = new AssinaturasService();

export interface Assinatura {
    _id: string;
    status: number;
    planoId?: string;
    clienteId?: string;
    clientName?: string;
    planName?: string;
    startAt?: string;
    nextBillingAt?: string;
    price?: number;
    [key: string]: any;
}

interface AssinaturasContextProps {
    data: Assinatura[];
    loading: boolean;
    error: boolean;
    reloadData: () => Promise<void>;
}

const AssinaturasContext = createContext<AssinaturasContextProps | undefined>(
    undefined,
);

export const useAssinaturasContext = () => {
    const context = useContext(AssinaturasContext);
    if (!context) {
        throw new Error(
            'useAssinaturasContext must be used within an AssinaturasProvider',
        );
    }
    return context;
};

export const AssinaturasProvider = ({ children }: { children: ReactNode }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [data, setData] = useState<Assinatura[]>([]);

    const reloadData = async () => {
        try {
            setError(false);
            const result = await service.findAll().then((res) => res?.data || []);
            setData(result);
        } catch (error) {
            console.error('Error fetching Assinaturas:', error);
            setError(true);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        reloadData();
    }, []);

    return (
        <AssinaturasContext.Provider value={{ data, reloadData, loading, error }}>
            {children}
        </AssinaturasContext.Provider>
    );
};
